import React from 'react';
import { RouteComponentProps, Switch, Route, Redirect } from 'react-router-dom';

import { RoomRatePlanListPage, EditRoomRatePlanPage, CreateRoomRatePlanPage } from './pages';

interface Props extends RouteComponentProps {
  isAdmin: boolean;
}
export const RoomRatePlansRoutes: React.FC<Props> = ({ match, isAdmin }) => {
  return (
    <Switch>
      <Route path={match.path} exact component={RoomRatePlanListPage} />
      {isAdmin && <Route path={`${match.path}/add`} component={CreateRoomRatePlanPage} />}
      {isAdmin && <Route path={`${match.path}/:ratePlanId`} component={EditRoomRatePlanPage} />}
      <Redirect to={match.path} />
    </Switch>
  );
};
